export enum BuilderProjectType {
    BUILDER_PROJECT = "builder_project",
    RULE_SET = "rule_set",
}
